// extracted by mini-css-extract-plugin
export var icon = "_72-1";
export var subtext = "_72-0";